export var getDefaultStyleSheet = _ref => {
  var {
    checked,
    designContext,
    error,
    interactiveState,
    keyboardFocused,
    warning
  } = _ref;
  var successState = error ? 'error' : warning ? 'warning' : 'default';
  var checkedState = checked ? 'checked' : 'default';
  var backgroundColor = designContext.get('radio-bullet/background-color', {
    interactiveState,
    successState,
    checkedState
  });
  var borderColor = designContext.get('radio-bullet/border-color', {
    interactiveState,
    successState,
    checkedState
  });
  var innerCircleBackgroundColor = designContext.get('radio-bullet/inner-circle-background-color', {
    interactiveState,
    successState,
    checkedState
  });
  var borderRadius = designContext.get('radio-bullet/corner-radius').pixelValue;
  return {
    wrapperStyle: {
      width: 20,
      height: 20,
      position: 'relative'
    },
    overflowingCircleStyle: {
      width: 30,
      height: 30,
      position: 'absolute',
      borderWidth: 2,
      borderStyle: 'solid',
      left: -5,
      top: -5,
      borderRadius,
      borderColor: keyboardFocused ? borderColor.toString() : designContext.get('colors/borders/transparent').toString(),
      transition: 'background-color .2s ease'
    },
    solidColorStyle: {
      width: 20,
      height: 20,
      top: 0,
      left: 0,
      position: 'absolute',
      borderRadius,
      backgroundColor: backgroundColor.toString(),
      transition: 'background-color .2s ease'
    },
    borderStyle: {
      borderColor: borderColor.toString(),
      borderStyle: 'solid',
      borderWidth: 1,
      width: 20,
      height: 20,
      borderRadius,
      position: 'absolute',
      transition: 'background-color .2s ease, border-color .2s ease',
      top: 0,
      left: 0
    },
    innerCircleStyle: {
      width: 6,
      height: 6,
      top: 7,
      left: 7,
      position: 'absolute',
      borderRadius,
      backgroundColor: checked ? innerCircleBackgroundColor.toString() : designContext.get('colors/backgrounds/transparent').toString(),
      transition: 'background-color .2s ease'
    },
    inputStyle: {
      height: 0,
      opacity: 0,
      position: 'absolute',
      width: 0,
      left: 0,
      top: 0,
      pointerEvents: 'none'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map